import { restClient } from '../config/restClient'

const endpoint = hiringTeamId => `/api/company/v2/hiring_teams/${hiringTeamId}/impersonated_hiring_team_members`

export const getImpersonatedMemberProfile = async hiringTeamId => {
  const response = await restClient(endpoint(hiringTeamId), {
    method: 'GET',
  })
  return response.data
}
